// extracted by mini-css-extract-plugin
module.exports = {"root":"radio-style_root__1yrt4"};